/**
 * Stockage de l'access token en mémoire JS pure — jamais localStorage/sessionStorage.
 * Contrat v1.1 (spécs/2_REFERENCE_FRONTEND_FINAL.md §3.2) : un token en localStorage est
 * lisible par tout script injecté (XSS). Perdu au rechargement de page → récupéré par un
 * refresh silencieux (déclenché par le premier 401 rencontré, cf. ApiClient.request()).
 *
 * Le refresh token n'a plus sa place ici : il vit dans un cookie httpOnly posé par le
 * backend, jamais lu ni stocké par le JS.
 */
let accessTokenEnMemoire: string | null = null;

export const tokenStorage = {
  setAccessToken(token: string): boolean {
    accessTokenEnMemoire = token;
    return true;
  },

  getAccessToken(): string | null {
    return accessTokenEnMemoire;
  },

  clearTokens(): void {
    accessTokenEnMemoire = null;
  },
};
